/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Totals_SessionsInputs */

const en_us2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workouts this month`)
};

const pt_br2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos no mês`)
};

const es_419_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamientos del mes`)
};

const pt_pt2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos no mês`)
};

const fr_fr2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances ce mois-ci`)
};

const de_de2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings diesen Monat`)
};

const it_it2_progress_totals_sessions = /** @type {(inputs: Progress_Totals_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamenti nel mese`)
};

/**
* | output |
* | --- |
* | "Workouts this month" |
*
* @param {Progress_Totals_SessionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_totals_sessions = /** @type {((inputs?: Progress_Totals_SessionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Totals_SessionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_totals_sessions(inputs)
	if (locale === "es-419") return es_419_progress_totals_sessions(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_totals_sessions(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_totals_sessions(inputs)
	if (locale === "de-DE") return de_de2_progress_totals_sessions(inputs)
	if (locale === "it-IT") return it_it2_progress_totals_sessions(inputs)
	return en_us2_progress_totals_sessions(inputs)
});
export { progress_totals_sessions as "progress.totals_sessions" }